import React from 'react';

const ServicioNoDisponible = ({ mensaje }) => {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      height: '100%',
      minHeight: '30vh',
      padding: '20px',
      boxSizing: 'border-box',
      textAlign: 'center',
      color: '#666'
    }}>
      {/* Icono de reparación / No pase */}
      <div style={{ marginBottom: '15px' }}>
        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
          {/* Señal de tráfico triangular (advertencia) */}
          <path d="M32 4L4 56H60L32 4Z" fill="#FFC107" stroke="#333" strokeWidth="4" strokeLinejoin="round"/>
          {/* Símbolo de construcción / barrera dentro */}
          <rect x="22" y="24" width="20" height="4" fill="#333" rx="1" />
          <rect x="22" y="32" width="20" height="4" fill="#333" rx="1" />
          <rect x="22" y="40" width="20" height="4" fill="#333" rx="1" />
          <path d="M28 20L28 48" stroke="#333" strokeWidth="2" strokeLinecap="round"/>
          <path d="M36 20L36 48" stroke="#333" strokeWidth="2" strokeLinecap="round"/>
        </svg>
      </div>
      
      <div style={{
        fontSize: '1.8vh',
        fontFamily: 'Inter',
        fontWeight: 'bold',
        color: '#333',
        marginBottom: '1vh'
      }}>
        Servicio No Disponible
      </div>
      
      <div style={{
        fontSize: '1.6vh',
        fontFamily: 'Inter',
        maxWidth: '80%'
      }}>
        {mensaje || "En este momento no podemos consultar las sedes. Por favor intente más tarde."}
      </div>
    </div>
  );
};

export default ServicioNoDisponible;
